import { render } from "./PodiumCard.vue?vue&type=template&id=632c83ea"
import script from "./PodiumCard.vue?vue&type=script&lang=js"
export * from "./PodiumCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__